var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.wideScreen
    ? _c(
        "div",
        {
          staticStyle: {
            overflow: "hidden",
            padding: "10px",
            "padding-left": "0 !important",
          },
        },
        [
          _c(
            "div",
            {
              class: {
                "d-flex": true,
                "text-white": true,
                darkmode: _vm.isDarkMode,
                open: _vm.isOpen,
              },
              attrs: { id: "chat-stats" },
            },
            [
              _c(
                "div",
                { attrs: { id: "hide-noise" } },
                [
                  _c(
                    "a-popover",
                    {
                      attrs: {
                        placement: "bottom",
                        trigger: "click",
                        overlayClassName: "chat-stats-popover",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "content",
                            fn: function () {
                              return [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "right",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                      },
                                    ],
                                    staticClass: "system-statistic child",
                                    attrs: { content: _vm.$t("stats.total") },
                                  },
                                  [
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.stats.totalActive) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t("message.totalBg")
                                            .toLocaleLowerCase()
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "right",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                      },
                                    ],
                                    staticClass: "system-statistic child",
                                    attrs: { content: _vm.$t("stats.total") },
                                  },
                                  [
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.isAdmin
                                              ? 0
                                              : _vm.activeConversations.length
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t("message.activeBg")
                                            .toLocaleLowerCase()
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "right",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                      },
                                    ],
                                    staticClass: "system-statistic child",
                                    attrs: { content: _vm.$t("stats.waiting") },
                                  },
                                  [
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.stats.waiting) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t("message.waitingBg")
                                            .toLocaleLowerCase()
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "right",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                      },
                                    ],
                                    staticClass: "system-statistic child",
                                    attrs: { content: _vm.$t("stats.late") },
                                  },
                                  [
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.stats.late) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t("message.lateBg")
                                            .toLocaleLowerCase()
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "right",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                      },
                                    ],
                                    staticClass: "system-statistic child",
                                    attrs: { content: _vm.$t("stats.free") },
                                  },
                                  [
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.stats.free) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t("message.freeBg")
                                            .toLocaleLowerCase()
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "right",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                      },
                                    ],
                                    staticClass: "system-statistic child",
                                    attrs: { content: _vm.$t("stats.chatbot") },
                                  },
                                  [
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.stats.chatbot) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t("message.chatbotChatCount")
                                            .toLocaleLowerCase()
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "right",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                      },
                                    ],
                                    staticClass: "system-statistic child",
                                    attrs: { content: _vm.$t("stats.chatbot") },
                                  },
                                  [
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.systemMaxChatCapacity) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t("message.maxCapacityBg")
                                            .toLocaleLowerCase()
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "tippy",
                                        rawName: "v-tippy",
                                        value: {
                                          followCursor: true,
                                          placement: "right",
                                          theme: _vm.isDarkMode
                                            ? "light-border"
                                            : "google",
                                        },
                                        expression:
                                          "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                      },
                                    ],
                                    staticClass: "system-statistic child",
                                    attrs: { content: _vm.$t("stats.pco") },
                                  },
                                  [
                                    _c("div", { staticClass: "value" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            Math.round(_vm.activeAgentRate) +
                                              "%"
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "content" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("message.pco").toUpperCase()
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        4196565587
                      ),
                      model: {
                        value: _vm.statisticVisible,
                        callback: function ($$v) {
                          _vm.statisticVisible = $$v
                        },
                        expression: "statisticVisible",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          on: {
                            mouseover: _vm.stopAnimation,
                            click: _vm.visibleStatistic,
                            mouseleave: _vm.startAnimation,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.animationItem == 0,
                                  expression: "animationItem == 0",
                                },
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "right",
                                    theme: _vm.isDarkMode
                                      ? "light-border"
                                      : "google",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                },
                              ],
                              staticClass: "system-statistic animation",
                              attrs: { content: _vm.$t("stats.maxCapacity") },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "value" },
                                [
                                  _c("a-progress", {
                                    attrs: {
                                      type: "circle",
                                      percent: Math.round(_vm.activeAgentRate),
                                      strokeWidth: 10,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("message.pco").toUpperCase())
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.animationItem == 1,
                                  expression: "animationItem == 1",
                                },
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "right",
                                    theme: _vm.isDarkMode
                                      ? "light-border"
                                      : "google",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                },
                              ],
                              staticClass: "system-statistic animation",
                              attrs: { content: _vm.$t("stats.total") },
                            },
                            [
                              _c("div", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.stats.totalActive)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$t("message.totalBg")
                                      .toLocaleLowerCase()
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.animationItem == 2,
                                  expression: "animationItem == 2",
                                },
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "right",
                                    theme: _vm.isDarkMode
                                      ? "light-border"
                                      : "google",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                },
                              ],
                              staticClass: "system-statistic animation",
                              attrs: { content: _vm.$t("stats.active") },
                            },
                            [
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.isAdmin
                                      ? 0
                                      : _vm.activeConversations.length
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$t("message.activeBg")
                                      .toLocaleLowerCase()
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.animationItem == 3,
                                  expression: "animationItem == 3",
                                },
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "right",
                                    theme: _vm.isDarkMode
                                      ? "light-border"
                                      : "google",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                },
                              ],
                              staticClass: "system-statistic animation",
                              attrs: { content: _vm.$t("stats.waiting") },
                            },
                            [
                              _c("div", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.stats.waiting)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$t("message.waitingBg")
                                      .toLocaleLowerCase()
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.animationItem == 4,
                                  expression: "animationItem == 4",
                                },
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "right",
                                    theme: _vm.isDarkMode
                                      ? "light-border"
                                      : "google",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                },
                              ],
                              staticClass: "system-statistic animation",
                              attrs: { content: _vm.$t("stats.late") },
                            },
                            [
                              _c("div", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.stats.late)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.lateBg").toLocaleLowerCase()
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.animationItem == 5,
                                  expression: "animationItem == 5",
                                },
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "right",
                                    theme: _vm.isDarkMode
                                      ? "light-border"
                                      : "google",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                },
                              ],
                              staticClass: "system-statistic animation",
                              attrs: { content: _vm.$t("stats.free") },
                            },
                            [
                              _c("div", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.stats.free)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("message.freeBg").toLocaleLowerCase()
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.animationItem == 6,
                                  expression: "animationItem == 6",
                                },
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "right",
                                    theme: _vm.isDarkMode
                                      ? "light-border"
                                      : "google",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                },
                              ],
                              staticClass: "system-statistic animation",
                              attrs: { content: _vm.$t("stats.chatbot") },
                            },
                            [
                              _c("div", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.stats.chatbot)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$t("message.chatbotChatCount")
                                      .toLocaleLowerCase()
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.animationItem == 7,
                                  expression: "animationItem == 7",
                                },
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    followCursor: true,
                                    placement: "right",
                                    theme: _vm.isDarkMode
                                      ? "light-border"
                                      : "google",
                                  },
                                  expression:
                                    "{\n                            followCursor: true,\n                            placement: 'right',\n                            theme: isDarkMode ? 'light-border' : 'google',\n                        }",
                                },
                              ],
                              staticClass: "system-statistic animation",
                              attrs: { content: _vm.$t("stats.maxCapacity") },
                            },
                            [
                              _c("div", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.systemMaxChatCapacity)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$t("message.maxCapacityBg")
                                      .toLocaleLowerCase()
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }